<template>
  <div class="header-v3">
    <div class="header-left">
      <div class="header-title">
          <svg-icon class="header-back-icon" v-if="showBack" @click.native='handleBack' name="icon-16-go" ></svg-icon>
          <span class="header-title-v3">{{ name }}</span>
          <slot name="subtitle"></slot>
      </div>
      <div v-if="showTips" class="header-tips-v3">{{ tips }}</div>
    </div>
    <div class="header-v3-tab">
      <common-tabs
          v-if="list.length"
          :activTabsId="activTabsId"
          :list='list'
          @handleClick="handlerBarClick">
        </common-tabs>
    </div>
    <div class="header-right">
      <slot></slot>
      <common-button size="small" type="primary" v-if="addTips" @click="headerRightBtn">{{ addTips }}</common-button>
      <div @click="eldGuideClick" v-if="showEldGuide" class="mainButton">
        <p v-if="showEldGuide" class="text">ELD Integration Guidance</p>
        <svg-icon class="guide" v-if="showEldGuide"  name="info-eld" ></svg-icon>
      </div>
    </div>
    <slot name="custom"></slot>
  </div>
</template>
<script>
import commonTabs from "../../../components-v2/common-tabs/index";
export default {
  name: 'common-header-v3',
  components: { commonTabs },
  data() {
    return {

    }
  },
  props: {
    name: {
      type: String,
      default: '',
      require: true
    },
    showTips: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    activTabsId: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    addTips: {
      type: String,
      default: ''
    },
    showBack: {     // 显示回退按钮
      type: Boolean,
      default: false
    },
    showEldGuide: {     // 显示回退按钮
      type: Boolean,
      default: false
    },
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handlerBarClick(node) {
      this.$emit('changeBarClick', node)
    },
    eldGuideClick() {
      this.$emit('changeEldGuide')
    },
    headerRightBtn() {
      this.$emit('headerRightClick')
    },
    handleBack() {
      this.$emit('handleBack')
    }
  }
}
</script>
<style lang="scss">
.header-v3 {
  .common-button+.common-button {
    margin-left: 12px;
  }
}
</style>
<style lang="scss" scoped>
.header-title-v3 {
  font-family: OpenSans-Semibold;
  font-size: 20px;
  color: #000000;
  height: 28px;
}

.header-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-left {
  // margin-bottom: 14px;
  // margin-top: 3px;
  padding-bottom: 16px;
}

.header-tips-v3 {
  margin-top: 10px;
  font-weight: 500;
  font-size: 14px;
  color: #7F8596;
}

.header-v3 {
  width: 100%;
  padding-top: 16px;
  // padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  // border-bottom: 1px solid #DADCE1;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06), inset 0 -1px 0 0 #dadce1;

  /deep/ {
    .tp-tabs {
      width: auto;

      .el-tabs__item {
        // font-weight: bold;
        color: #4c556c;
        margin: 0 13px;
        padding: 0 6px !important;

        &.is-active {
          font-weight: bold;
          font-weight: bold;
          color: #4066d4 !important;
          border-bottom: none;

          &:after {
            content: '';
            width: 100%;
            height: 3px;
            background: #4066d4;
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
            border-radius: 4px 4px 0 0;
          }
        }
      }

    }
  }
}

.header-v3-tab {
  margin-left: 24px;
  // padding-left: 10px;
  flex: 1;
  align-self: flex-end;

  /deep/ .tp-tabs {
    // margin-bottom: 0;
  }
}

.header-right {
  align-self: flex-start;
  z-index: 2;

  /deep/ {
    .common-button {
      transform: translateY(-2px);
    }
  }
}

.header-back-icon {
  transform: rotate(180deg);
  cursor: pointer;
  margin-right: 12px;
}

.mainButton {

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;

  width: 173px;
  height: 16px;
  margin-top: 5px;
  cursor: pointer;

  .text {
    width: 153px;
    height: 16px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #4066D4;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .guide {
    width: 16px;
    height: 16p;

  }
}
</style>
